import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";

import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Timeline from "@/components/sections/Timeline";
import MediaMarquee from "@/components/sections/MediaMarquee";
import Articles from "@/components/sections/Articles";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import NotFound from "@/pages/NotFound";
import ArticlesList from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminComments from "@/pages/admin/AdminComments";
import AdminSocial from "@/pages/admin/AdminSocial";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminStats from "@/pages/admin/AdminStats";
import AdminTimeline from "@/pages/admin/AdminTimeline";
import AdminOutlets from "@/pages/admin/AdminOutlets";

const Landing = () => (
  <div className="App bg-ink text-bone min-h-screen">
    <Header />
    <main>
      <Hero />
      <About />
      <Timeline />
      <MediaMarquee />
      <Articles />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/account"
              element={
                <RequireAuth>
                  <Account />
                </RequireAuth>
              }
            />
            <Route path="/articles" element={<ArticlesList />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />

            <Route
              path="/admin"
              element={
                <RequireAuth role="admin">
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<AdminOverview />} />
              <Route path="members" element={<AdminMembers />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="comments" element={<AdminComments />} />
              <Route path="content/about" element={<AdminAbout />} />
              <Route path="content/stats" element={<AdminStats />} />
              <Route path="content/timeline" element={<AdminTimeline />} />
              <Route path="content/outlets" element={<AdminOutlets />} />
              <Route path="social" element={<AdminSocial />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
